import { Skeleton, Stack, styled } from '@mui/material';

export const SmallSkeleton = styled(Skeleton)({
  borderRadius: '16px',
  width: '60%',
  height: '42px'
});

export const LargeSkeleton = styled(Skeleton)({
  borderRadius: '16px',
  width: '100%',
  height: '100px'
});

export const UserStack = styled(Stack)({
  flexDirection: 'row',
  justifyContent: 'flex-end'
});
